import { HeaderContainer } from './container';

const App = () => {
  return (
    <>
      <HeaderContainer />
    </>
  )
}

export default App